import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent, GridInfo, ModelSchema } from 'tnx-shared';
import { WorkflowStepService } from 'tnx-admin-service/workflowcore/workflowstep/services';
@Component({
	selector: 'workflowstep',
	templateUrl: './workflowstep.component.html',
	styleUrls: ['./workflowstep.component.scss'],
	providers: [ComponentContextService],
})
export class WorkflowStepComponent extends DataListBase implements OnInit, AfterViewInit {
	@ViewChild('crudList', { static: false }) crudList: CrudListComponent;
	searchSchema: any = {};
	searchData: any = {};
	constructor(
		protected _injector: Injector,
		protected _workflowStepService: WorkflowStepService,
	) {
		super(_injector);
	}

	ngOnInit() {
		this.setting.baseService = this._workflowStepService;
		this.setting.modelSchemas = [
			new ModelSchema({ field: 'longId', dataType: 'int', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'createTime', dataType: 'date', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'stepId', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'stepCode', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'status', dataType: 'int', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'workflowDefinitionId', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'stepType', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'httpRequest', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'deadline', dataType: 'int', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'isDate', dataType: 'boolean', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'persistenceId', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'stepName', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'autoFinish', dataType: 'boolean', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'key', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'value', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'code', name: '', fullName: '', description: '' })
		];

		this.setting.cols = [
			new ColumnSchemaBase({ field: 'longId' }),
			new ColumnSchemaBase({ field: 'createTime' }),
			new ColumnSchemaBase({ field: 'stepId' }),
			new ColumnSchemaBase({ field: 'stepCode' }),
			new ColumnSchemaBase({ field: 'status' }),
			new ColumnSchemaBase({ field: 'workflowDefinitionId' }),
			new ColumnSchemaBase({ field: 'stepType' }),
			new ColumnSchemaBase({ field: 'httpRequest' }),
			new ColumnSchemaBase({ field: 'deadline' }),
			new ColumnSchemaBase({ field: 'isDate' }),
			new ColumnSchemaBase({ field: 'persistenceId' }),
			new ColumnSchemaBase({ field: 'stepName' }),
			new ColumnSchemaBase({ field: 'autoFinish' }),
			new ColumnSchemaBase({ field: 'key' }),
			new ColumnSchemaBase({ field: 'value' }),
			new ColumnSchemaBase({ field: 'currentStateCode' }),
			new ColumnSchemaBase({ field: 'code' })
		];

		super.ngOnInit();
	}
}

